import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import styles from "./ValueProposition.module.css";

const values = [
  {
    id: 1,
    heading: "Authenticity fans can trust",
    text: "Every memory is permanently linked to your verified signature and identity on-chain — making forgery impossible.",
    image: "/authograph.jpg",
    reverse: false
  },
  {
    id: 2,
    heading: "Moments become revenue",
    text: "Your best plays, artwork, or posts can instantly generate income through direct sales and fan support.",
    image: "/moments-revenue.jpg",
    reverse: true
  },
  {
    id: 3,
    heading: "Share anywhere",
    text: "From social media to stadium screens — distribute your signed memories anywhere your audience is.",
    image: "/share-athlete.jpg",
    reverse: false
  }
];

const ValueProposition = ({ className = "" }) => {
  return (
    <section className={[styles.valueSection, className].join(" ")}>
      <Typography className={styles.sectionTitle} component="h1">
        Why creators choose MementoMaster
      </Typography>

      {values.map((item) => (
        <Box
          key={item.id}
          className={`${styles.valueBlock} ${item.reverse ? styles.reverse : ""}`}
        >
          <Box className={styles.imageContainer}>
            <img src={item.image} alt={item.heading} className={styles.valueImage} />
            <div className={styles.gradientOverlay}></div>
          </Box>
          <Box className={styles.textContainer}>
            <Typography className={styles.valueHeading}>{item.heading}</Typography>
            <Typography className={styles.valueText}>{item.text}</Typography>
          </Box>
        </Box>
      ))}
    </section>
  );
};

ValueProposition.propTypes = {
  className: PropTypes.string,
};

export default ValueProposition;